import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { StringFilter } from "clarity-angular";
import { Router } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { VMwareProducts } from '../models/vmwareproducts';
import { ReportsService } from '../services';
import { ProductReleases } from '../models/productreleases';
import { DatePipe } from '@angular/common';
import { locale } from 'core-js';
import { AdminService } from '../admin/admin.service';
import { ManageReleaseRequest } from '../models/update-release-request';
import { AuthService } from '../auth/authservice.service';
import { NumberConstants } from "../common/numberconstants";
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { Subscription } from 'rxjs';


/**
 * This defines manage release functions
 */
class ItemFilter implements StringFilter<string> {
    accepts(release: any, search: string): boolean {
        return release.rmVmwPrdRelVersion.toLowerCase().indexOf(search) >= 0;
    }
}

@Component({
    styleUrls: ['./managereleases.component.scss'],
    templateUrl: './managereleases.component.html'
})
export class ManageReleasesComponent implements OnInit {
    private itemFilter = new ItemFilter();
    langSub: Subscription;
    title: string = this.translateService.instant('admin.heading')
    vmwareProduct: string = "Default";
    vmwareProductId: number = this.numberconstants.MINUS_ONE;
    vmwareProductsError: string = this.translateService.instant('loadingVmProd');
    releaseError: string = this.translateService.instant('loadingVmProdMsgAdmins');
    locale: string = "";
    releases: Array<ProductReleases>;
    products: Array<VMwareProducts>;
    currentRelease: any;
    loaderEnabled: boolean = true;
    categoryCount: number = 0;
    loaderAlertType: string = "alert-info";
    showProducts:boolean = false;
    dataHeaders = [
        {
            name: this.translateService.instant('admin.releaseVersion'),
            class: "",
            filter: "itemFilter",
            hidden: false
        },
        {
            name: this.translateService.instant('admin.gaDate'),
            class: "",
            hidden: false
        },
        {
            name: this.translateService.instant('admin.publishedDate'),
            class: "",
            hidden: false
        },
        {
            name: this.translateService.instant('active'),
            class: "",
            hidden: false
        },
        {
            name: this.translateService.instant('admin.source'),
            class: "",
            hidden: false
        }
    ];
    deleteModalProps = {
        state: false,
        backdrop: true,
        closable: false,
        title: this.translateService.instant('admin.deleteRelease '),
        bodyContent: this.translateService.instant('admin.EnableRelMsg'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('adminGridOption.delete'),
        cancelBClass: "btn-outline",
        okBClass: "btn-danger"
    };
    statusChangeModalProps = {
        state: false,
        backdrop: true,
        closable: false,
        title: this.translateService.instant('release'),
        bodyContent: this.translateService.instant('admin.EnableRelMsg'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('adminGridOption.disable'),
        cancelBClass: "btn-outline",
        okBClass: "btn-danger"
    };
    addModalProps = {
        state: false,
        backdrop: true,
        closable: false,
        size: "lg",
        title: this.translateService.instant('addRel'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('addString'),
        cancelBClass: "btn-outline",
        okBClass: "btn-primary"
    };
    updateModalProps = {
        state: false,
        backdrop: true,
        closable: false,
        size: "lg",
        title: this.translateService.instant('admin.editUpdateRel'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('update'),
        cancelBClass: "btn-outline",
        okBClass: "btn-primary"
    };

    constructor(private alertService: AlertService, @Inject(LOCALE_ID) _locale: string,
        private reportService: ReportsService, private adminService: AdminService,
        private authService: AuthService, private router: Router,private numberconstants: NumberConstants, private translateService: TranslateService, private envService: EnvironmentsService) {
        this.locale = _locale;
    }

    deleteModalHandler(btnOutput: boolean) {
        if (btnOutput) {
            this.loaderEnabled = true;
            this.adminService.deleteRelease(this.vmwareProductId, this.currentRelease.id)
                .subscribe(
                    response => {
                        if (response.status && response.status === "OK") {
                            this.alertService.success(this.deleteModalProps.title + " - "+ this.translateService.instant('deletedSuccessMsg'), true);
                            this.getReleases(this.vmwareProductId);
                            this.loaderEnabled = false;
                        } else {
                            this.alertService.error(this.deleteModalProps.title + " - " + response.message, true);
                            this.loaderEnabled = false;
                        }
                    },
                    err => {
                        console.log(err);
                        this.alertService.error(this.deleteModalProps.title + " - Unable to delete.", true);
                        this.loaderEnabled = false;
                    });
        } else {
            this.alertService.warn(this.deleteModalProps.title + this.translateService.instant('noChnagesAlertLabel'), true);
        }
    }

    statusChangeModalHandler(btnOutput: boolean) {
        if (btnOutput) {
            let releaseReq: ManageReleaseRequest = this.getManageReleaseRequest(this.currentRelease);
            if (releaseReq.isActive === true) {
                releaseReq.isActive = false;
            } else {
                releaseReq.isActive = true;
            }
            this.loaderEnabled = true;
            this.adminService.updateRelease(releaseReq)
                .subscribe(
                    response => {
                        if (response.status && response.status === "OK") {
                            this.alertService.success(this.statusChangeModalProps.title + this.translateService.instant('changesCompleted'), true);
                            this.getReleases(this.vmwareProductId);
                            this.loaderEnabled = false;
                        } else {
                            this.alertService.error(this.statusChangeModalProps.title + " - " + response.message, true);
                            this.loaderEnabled = false;
                        }
                    },
                    err => {
                        console.log(err);
                        this.alertService.error(this.statusChangeModalProps.title + " - Unable to changes status of release.", true);
                        this.loaderEnabled = false;
                    });
        } else {
            this.alertService.warn(this.statusChangeModalProps.title + this.translateService.instant('noChnagesAlertLabel'), true);
        }
    }

    addModalHandler(release: any) {
        if (release) {
            let releaseReq: ManageReleaseRequest = this.getManageReleaseRequest(release);
            this.loaderEnabled = true;
            this.adminService.addRelease(releaseReq)
                .subscribe(
                    response => {
                        if (response.status && response.status === "OK") {
                            this.alertService.success(this.addModalProps.title + " - Changes completed successfully", true);
                            this.getReleases(this.vmwareProductId);
                            this.loaderEnabled = false;
                        } else {
                            this.alertService.error(this.addModalProps.title + " - " + response.message, true);
                            this.loaderEnabled = false;
                        }
                    },
                    err => {
                        console.log(err);
                        this.alertService.error(this.addModalProps.title + " - " + JSON.parse(err._body).message, true);
                        this.loaderEnabled = false;
                    });
        } else {
            this.alertService.warn(this.addModalProps.title + this.translateService.instant('noChnagesAlertLabel'), true);
        }
    }

    updateModalHandler(btnOutput: boolean) {
        if (btnOutput) {
            let releaseReq: ManageReleaseRequest = this.getManageReleaseRequest(this.currentRelease);
            this.loaderEnabled = true;
            this.adminService.updateRelease(releaseReq)
                .subscribe(
                    response => {
                        if (response.status && response.status === "OK") {
                            this.alertService.success(this.updateModalProps.title + " Unable to fetch Omnissa product list.", true);
                            this.getReleases(this.vmwareProductId);
                            this.loaderEnabled = false;
                        } else {
                            this.alertService.error(this.updateModalProps.title + " - " + response.message, true);
                            this.loaderEnabled = false;
                        }
                    },
                    err => {
                        console.log(err);
                        this.alertService.error(this.updateModalProps.title + " - Unable to update release.", true);
                        this.loaderEnabled = false;
                    });
        } else {
            this.alertService.warn(this.updateModalProps.title + this.translateService.instant('noChnagesAlertLabel'), true);
        }
    }

    /**
     * Get Omnissa  products for manage releases screen
     */
    getVMwareProducts(): void {
        this.loaderAlertType = "alert-info";
        this.reportService.getReleases(this.reportService.roleIds)
            .subscribe(
                vmwareProducts => {
                    this.products = vmwareProducts;
                    if (!this.products || this.products.length === this.numberconstants.ZERO) {
                        this.loaderAlertType = "alert-danger";
                        this.vmwareProductsError = "Omnissa product list is not available.";
                    }
                },
                err => {
                    console.log(err);
                    this.loaderAlertType = "alert-danger";
                    this.vmwareProductsError = "Unable to fetch Omnissa product list.";
                });
    }

    /**
     * set Omnissa releases
     * @param e
     */
    loadVMwareReleases(e): void {
        let productId = parseInt(e.target['value'], this.numberconstants.TEN);
        for (let i = this.numberconstants.ZERO; i < this.products.length; i++) {
            let element = this.products[i];
            if (element.id === productId) {
                this.vmwareProduct = element.rmVmwProduct.toString();
                break;
            }
        };
        if (productId !== this.numberconstants.MINUS_ONE) {
            this.getReleases(productId);
        }
    }

    /**
     * Extract Omnissa releases for the given product
     * @param prodctId
     */
    getReleases(productId): void {
        this.loaderEnabled = true;
        this.reportService.getProductVersions(productId.toString(), this.numberconstants.ONE)
            .subscribe(
                productReleases => {
                    this.releases = productReleases;
                    if (!this.releases || this.releases.length === this.numberconstants.ZERO) {
                        this.releaseError = "Omnissa product release list is not available for selected product : " + this.vmwareProduct;
                    }
                    this.loaderEnabled = false;
                },
                err => {
                    console.log(err);
                    this.releaseError = this.translateService.instant('admin.emptyDataGridMsg') + this.vmwareProduct;
                    this.loaderEnabled = false;
                });
    }

    verifyIfCategoriesMapped(release): void {
        this.loaderEnabled = true;
        this.reportService.getMaximumCategoriesByProductIdAndVersionId(this.vmwareProductId, release.id).subscribe(
            categories => {
                if (categories && categories.length > this.numberconstants.ZERO) {
                    this.alertService.error(this.deleteModalProps.title +
                        this.translateService.instant('admin.deleteRelMsg'));
                    window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_5000);
                } else {
                    this.deleteModalProps.state = true;
                }
                this.loaderEnabled = false;
            },
            err => {
                console.log(err);
                this.alertService.error(this.deleteModalProps.title +
                    " - Unable to verify categories mapped to the release. Please try again later");
                window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_5000);
                this.loaderEnabled = false;
            });
    }

    /**
     * Load modal with Selected release information
     * @param release
     */
    loadEditModal(release: any): void {
        this.updateModalProps.title = this.translateService.instant('admin.editUpdateRel');
        this.currentRelease = JSON.parse(JSON.stringify(release));
        this.currentRelease.rmVmwPrdRelGADate = new DatePipe(this.locale).transform(this.currentRelease.rmVmwPrdRelGADate, 'yyyy-MM-dd');
        this.currentRelease.cmRelPublishDate = new DatePipe(this.locale).transform(this.currentRelease.cmRelPublishDate, 'yyyy-MM-dd');
        this.updateModalProps.title = this.updateModalProps.title + " : " + this.currentRelease.rmVmwPrdRelVersion;
        this.updateModalProps.state = true;
    }

    /**
     * Load modal with empty fields to add a release
     */
    loadAddModal(): void {
        this.currentRelease = new ProductReleases();
        this.addModalProps.state = true;
    }

    /**
     *  load confirmation modal to delete selected release
     * @param release
     */
    loadDeleteModal(release: any): void {
        this.deleteModalProps.title = this.translateService.instant('admin.deleteRelease ');
        this.currentRelease = JSON.parse(JSON.stringify(release));
        this.deleteModalProps.title = this.deleteModalProps.title + " : " + this.currentRelease.rmVmwPrdRelVersion;
        this.verifyIfCategoriesMapped(release);
    }

    /**
     * load confirmation modal to Enable/Disable selected release. Here type indicated Enable/Disable
     * @param release
     * @param type
     */
    loadStatusChangeModal(release: any, type: string): void {
        this.statusChangeModalProps.title = this.translateService.instant('release');
        this.currentRelease = JSON.parse(JSON.stringify(release));
        this.currentRelease.rmVmwPrdRelGADate = new DatePipe(this.locale).transform(this.currentRelease.rmVmwPrdRelGADate, 'yyyy-MM-dd');
        this.currentRelease.cmRelPublishDate = new DatePipe(this.locale).transform(this.currentRelease.cmRelPublishDate, 'yyyy-MM-dd');
        this.statusChangeModalProps.title = type + " " + this.statusChangeModalProps.title + " : " + this.currentRelease.rmVmwPrdRelVersion;
        this.statusChangeModalProps.okButton = type;
        this.statusChangeModalProps.state = true;
    }

    ngOnInit() {
        this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
            // this.translateService.use(lang);
            this.title = this.translateService.instant('admin.heading');
            this.vmwareProductsError = this.translateService.instant('loadingVmProd');
            this.releaseError = this.translateService.instant('loadingVmProdMsgAdmins');
            this.dataHeaders[0].name = this.translateService.instant('admin.releaseVersion');
            this.dataHeaders[1].name = this.translateService.instant('admin.gaDate');
            this.dataHeaders[2].name = this.translateService.instant('admin.publishedDate');
            this.dataHeaders[3].name = this.translateService.instant('active');
            this.dataHeaders[4].name = this.translateService.instant('admin.source');
            this.deleteModalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg ');
            this.deleteModalProps.cancelButton = this.translateService.instant('cancel');
            this.deleteModalProps.okButton = this.translateService.instant('adminGridOption.delete');
            this.statusChangeModalProps.title = this.translateService.instant('release'),
            this.statusChangeModalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg'),
            this.statusChangeModalProps.cancelButton = this.translateService.instant('cancel');
            this.statusChangeModalProps.okButton = this.translateService.instant('adminGridOption.disable');
            this.addModalProps.title = this.translateService.instant('addRel');
            this.addModalProps.cancelButton = this.translateService.instant('cancel');
            this.addModalProps.okButton = this.translateService.instant('addString');
            this.updateModalProps.title = this.translateService.instant('admin.editUpdateRel');
            this.updateModalProps.cancelButton = this.translateService.instant('cancel');
            this.updateModalProps.okButton = this.translateService.instant('update');
            this.translateService.instant('noChnagesAlertLabel');
            this.translateService.instant('admin.emptyDataGridMsg');
            this.translateService.instant('admin.deleteRelMsg');
            this.translateService.instant('deletedSuccessMsg')
        });
     this.showProducts = this.authService.checkaction("SHOW_PRODUCTS");        
        if(!this.showProducts) {
            this.getVMwareProducts();
        }
    }

    /**
     * Converts Release API response object to Admin API request object
     * @param release
     */
    private getManageReleaseRequest(release: any): ManageReleaseRequest {
        let relReq: ManageReleaseRequest = new ManageReleaseRequest();
        if (!release.id) {
            delete relReq["releaseId"];
        } else {
            relReq.releaseId = release.id;
        }
        relReq.releaseVersion = release.rmVmwPrdRelVersion.toString();
        if (!release.displayName) {
            delete relReq["displayName"];
        } else {
            relReq.displayName = release.displayName.toString();
        }
        if (!release.rmVmwPrdRelId) {
            delete relReq["rmReleaseId"];
        } else {
            relReq.rmReleaseId = release.rmVmwPrdRelId;
        }
        relReq.productId = release.cmVmwProductId ? release.cmVmwProductId : this.vmwareProductId;
        relReq.releaseGADate = release.rmVmwPrdRelGADate + " 00:00:00";
        relReq.releasePublishDate = release.cmRelPublishDate + " 00:00:00";
        if (!release.support) {
            delete relReq["isActive"];
        } else {
            relReq.isActive = release.support;
        }
        relReq.description = release.decription ? release.decription.toString() : "";
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        relReq.updatedBy = currentUser.email;

        return relReq;
    }

    loadData(): Boolean {
        if (!this.showProducts) {
            return true;
        } else {
            this.router.navigate(['/home']);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/managereleases/managereleases.component.ts